import { useState, useCallback } from 'react';
import { api_call } from '../helpers/untils';

export function useCredentials() {
  const [clientSecret, setClientSecret] = useState({});
  const [step, setStep] = useState('idle'); // idle | loading | ready | saving | success | error
  const [error, setError] = useState(null);

  // Call when the modal opens — fetches a SetupIntent
  const initSetup = useCallback(async () => {
    setStep('loading');
    setError(null);
    try {
      let url = `/api/get-env-info`
      let response = await api_call(url, {
        method: 'GET',
      });
      if (response.ok) {
        const server_info = await response.json()
        setClientSecret(server_info)
        setStep('ready');
      } else {
        setError(response.message);
        setStep('error');
      }
    } catch (err) {
      setError(err.message);
      setStep('error');
    }
  }, []);

  return {
    step, error, clientSecret, initSetup
  };
}